export class ResetPassword {
  email: string;
  password: string;
  confirmPassword: string;
  code: string;
}



// WEBPACK FOOTER //
// ./src/app/core/models/reset-password.ts